PJQ.views.invoicing.PayableInvoicesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoices-list'),
        invoiceId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-create-invoice': 'newInvoice',
        'click .btn-delete-invoice': 'deleteInvoiceClicked',
        'click .btn-export': 'exportList'
    },
    beforeFirstRender: async function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.invoicing.PayableInvoices(null, {
                project: PJQ.app.session.project,
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchPayableInvoiceCustomFields();
        this.userSettings = await PJQ.app.session.fetchPayableInvoiceUserSettings();
        this.billingPeriodSettings = await this.options.project.fetchBillingPeriodSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.options.isAdmin = this.options.project.hasPermission('payableInvoices.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('payableInvoiceChanged');
        PJQ.app.session.project.on('payableInvoiceChanged', function (invoice) {
            this.collection.add(invoice);
            this.render();
        }, this);

        if (this.options.invoiceId > 0) {
            let initInvoice = this.collection.get(this.options.invoiceId);
            if (initInvoice != null) {
                this.viewInvoice(initInvoice, this.options.inviteResponse);
                this.options.invoiceId = null;
            }
        } else if (this.options.paymentId > 0) {
            let initPayment = new PJQ.models.invoicing.PayableInvoicePayment({
                id: this.options.paymentId
            });

            new PJQ.views.invoicing.InvoicePaymentModal({
                model: initPayment,
                isPayable: true
            });
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.invoicing.PayableInvoiceDataTable({
            el: this.$('.invoices-table'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            showAllBillingPeriods: this.options.showAllBillingPeriods,
            headerData: _.bind(function () {
                return {
                    billingPeriods: this.billingPeriodSettings ? this.billingPeriodSettings.billingPeriods : null,
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            groups: this.groups,
            costTypes: this.costTypes,
            unitsOfMeasure: this.unitsOfMeasure,
            userSettings: this.userSettings,
            billingPeriodSettings: this.billingPeriodSettings,
            canViewCommitments: this.options.canViewCommitments,
            settings: this.userSettings.getSettings(PJQ.constants.invoicing.view.PAYABLE_INVOICES),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: () => {
                this.userSettings.save();
            },
            onViewInvoice: (invoice) => {
                this.viewInvoice(invoice);
            },
            onRowDoubleClick: (row) => {
                this.viewInvoice(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    newInvoice: function () {
        this.viewInvoice();
    },
    viewInvoice: function (invoice, inviteResponse) {
        let isNew = invoice == null;
        new PJQ.views.invoicing.EditPayableInvoiceModal({
            model: invoice,
            inviteResponse: inviteResponse,
            commitment: this.model,
            onSave: (invoice) => {
                if (isNew) {
                    this.collection.add(invoice);
                }
                this.renderView();
            },
            onDelete: (invoice) => {
                this.collection.remove(invoice);
                this.renderView();
            }
        });
    },
    deleteInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteInvoice(row);
    },
    deleteInvoice: function (row) {
        if (row != null) {
            let invoice = row.data();
            if (invoice != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Invoice",
                    body: "Are you sure you want to delete this Invoice?",
                    onDelete: _.bind(function () {
                        invoice.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(invoice);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.invoicing.PayableInvoiceSettingsModal({
            invoicesView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    exportList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    }
});

PJQ.views.invoicing.ModalViewPayableInvoices = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-view-payable-invoices'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.invoicing.PayableInvoicesList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                showAllBillingPeriods: this.options.showAllBillingPeriods,
                project: this.options.project
            })
        }
    },
});